export default __webpack_public_path__ + "static/media/dimg7.aa48b717.jpg";